import { render, staticRenderFns } from "./FormatoPedidosNew.vue?vue&type=template&id=9bbd65fc&scoped=true"
import script from "./FormatoPedidosNew.vue?vue&type=script&lang=js"
export * from "./FormatoPedidosNew.vue?vue&type=script&lang=js"
import style0 from "./FormatoPedidosNew.vue?vue&type=style&index=0&id=9bbd65fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbd65fc",
  null
  
)

export default component.exports